import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'gatsby';
import { Checkbox, Form, SubmitButton, TextInput, TextArea, Select } from '../HookForm';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationSchema } from './form.validator';
import moment from 'moment';
import Cookie from 'js-cookie';
import OutboundLink from '../OutboundLink';
import useDrupalCsrfToken from '../HookForm/useDrupalCsrfToken';
import { months, days, years } from './birthday';

const AskExpertForm = () => {
  const cookie = Cookie.get('signup-ineligible');
  let isEligible = typeof cookie === 'undefined' ? true : false;
  const ageErrors = [];

  const [submitFailed, setSubmitFailed] = useState(false);
  //register resolver to useForm hook
  const { handleSubmit, getValues, register, formState } = useForm({
    resolver: yupResolver(validationSchema),
    // mode: 'onChange',
  });

  const csrfToken = useDrupalCsrfToken((err) => {
    window.location.pathname = '/form/askexpert';
  });

  const submitForm = (data) => {

    return axios
      .post(
        '/webform_rest/submit',
        {
          webform_id: 'askexpert',
          name: data.name,
          email: data.email,
          school_organization: data.school_organization,
          question: data.question,
          opt_in: data.opt_in,
        },
        {
          headers: {
            'X-CSRF-Token': csrfToken,
          },
        }
      )
      .catch((e) => {
        console.error(e);
        setSubmitFailed(true);
      });
  };

  const renderSuccess = () => {
    return (
      <>
        <p>Thank you for your question! We are now in the process of matching your question to the appropriate volunteer Data Expert for response. We will send a response to the email address you provided as soon as one of our Data Experts answers your question.</p>
        <p>*Please note: if questions are not related to the topic of data or data-driven careers, or are deemed inappropriate in nature, we reserve the right to abstain from answering. While we aim to answer all data-driven questions, not all questions will be displayed on the Discover Data <a href="https://www.discoverdatainschool.org/">website</a>. We may also abbreviate questions/answers displayed on the website in order to improve accessibility for visitors to the Discover Data website.</p>
      </>
    );
  };

  const ineligibleMessage =
    'You have to be 18 years of age or older to sign up for updates.';

  if (!isEligible) {
    ageErrors.push(ineligibleMessage);
  }

  const birthdayValidation = (values) => {
    const ageErrors = [];

    const birthday = moment(
      `${values['year']}/${values['month']}/${values['day']}`
    );

    const age = moment().diff(birthday, 'years');

    if (age < 18) {
      isEligible = false;
      ageErrors.push(ineligibleMessage);
      Cookie.set('signup-ineligible', 1, { expires: 1 });
    }
  };
  

  const renderForm = () => {
    return (
      <Form onSubmit={handleSubmit(submitForm)}>
        <p className="pt-1">
          Please submit your question about data-driven topics using the form below. We will make every effort to match a volunteer Data Expert with your question for response. This form is only to be completed by a parent/guardian, educator or other adult over 18 years of age on their own behalf or on behalf of their students/classroom. Thank you!
        </p>
        <TextArea
          type="textarea"
          label="Your Question to the Data Expert"
          name="question"
          required
          register={register}
          error={formState.errors.question?.message}
        />
        <TextInput
          type="text"
          label="Name"
          name="name"
          required
          register={register}
          error={formState.errors.name?.message}
        />
        <TextInput
          type="text"
          label="Email"
          name="email"
          required
          register={register}
          error={formState.errors.email?.message}
        />
        <TextInput
          type="text"
          label="School, Organization or District Name"
          name="school_organization"
          required
          register={register}
          error={formState.errors.school_organization?.message}
        />
        <label for="birthday" class="form__label form__label--required">Birthday</label>
        <div className="subscribe__birthday-fields">
          <Select
            label="Month"
            placeholder= 'Month'
            name="month"
            options={months}
            required
            register={register}
            error={formState.errors.month?.message}
          />
          <Select
            label="Day"
            placeholder= 'Day'
            name="day"
            options={days}
            required
            register={register}
            error={formState.errors.day?.message}
          />
          <Select
            label="Year"
            placeholder= 'Year'
            name="year"
            options={years}
            required
            register={register}
            error={formState.errors.year?.message}
          />
        </div>
        <p>You must be at least 18 years old to fill out this form. If you are under the age of 18, please ask a trusted adult to submit your question on your behalf</p>
        <Checkbox
          label={
            <>
              By signing-up and clicking this box, you agree to Discovery
              Education’s{' '}
              <OutboundLink to="https://www.discoveryeducation.com/privacy-policy/">
                Privacy Policy
              </OutboundLink>{' '}
              and to the Nielsen Foundation’s{' '}
              <Link to="/discover-data-privacy">Privacy Policy</Link>. Both
              entities may contact you as described in their policies.
            </>
          }
          name="opt_in"
          required
          register={register}
          error={formState.errors.opt_in?.message}
        />
        <SubmitButton onClick={() => {
          const values = getValues();
            birthdayValidation(values);
        }}>Submit</SubmitButton>
        {formState.isSubmitted && !formState.isValid && (
          <p style={{ color: '#bc2121' }}>
            <small>One or more fields have an invalid value.</small>
          </p>
        )}
      </Form>
    );
  };

  const renderSubmitFailed = () => (
    <>
      <p style={{ color: '#801300' }}>
        There was an error processing this form, please try again later.
      </p>
    </>
  );

  if ( isEligible ) {
    return (
      <div className="subscribe">
        <div className="classroom-form">
          <h2>Ask the Experts</h2>
          {submitFailed
            ? renderSubmitFailed()
            : formState.isSubmitSuccessful
            ? renderSuccess()
            : renderForm()}
        </div>
      </div>
    );
  } else {
    return (
      <div className="subscribe">
        <div className="classroom-form">
          <h2>Ask the Experts</h2>
          <p>{ineligibleMessage}</p>
        </div>
      </div>
    );
  }

};

export default AskExpertForm;
